<template>
  <div class="pa-3 grey lighten-4">
    <v-card class="card--flex-toolbar">
      <v-card-text class="pa-0">
        <v-form ref="form">
            <v-card-title class="grey lighten-4 pa-2">
                <h3 class="secondary--text">{{ $t("company.page.profile.section.basic_details") }}</h3>
                <v-spacer></v-spacer>
                <v-btn color="success" @click="$emit('onSave',film)" small>Save</v-btn>
            </v-card-title>
            <v-card-text class="px-0">
          <v-layout row wrap justify-center align-start>
            <v-flex xs12 md12 lg12>
              <v-form ref="form" onsubmit="return false;">
                <!-- About company -->
                <v-layout row wrap>
                  <v-flex xs12 class="px-3">
                    <v-text-field
                      v-model="company.title"
                      :label="$t('rms.field.title.label')"
                      color="primary"
                      :rules="[
                        rules.required,
                        rules.min_length(3),
                        rules.max_length(250),
                      ]"
                      counter="250"
                    >
                      <template v-slot:append>
                        <v-tooltip top color="white">
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on">mdi-information-outline</v-icon>
                          </template>
                          <div class="grey--text text--darken-3 body-1">
                            {{ $t("company.save.title.tooltip") }}
                          </div>
                        </v-tooltip>
                      </template></v-text-field
                    >
                    <v-text-field
                      v-model="company.slug"
                      color="primary"
                      :label="$t('rms.field.slug.label')"
                      :rules="[
                        rules.required,
                        rules.min_length(2),
                        rules.max_length(15),
                        rules.subdomain,
                      ]"
                      :hint="$t('company.save.slug.hint')"
                      counter="15"
                      readonly
                      ><template v-slot:append>
                        <v-tooltip top color="white">
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on">mdi-information-outline</v-icon>
                          </template>
                          <div class="grey--text text--darken-3 body-1">
                            {{ $t("company.save.slug.tooltip") }}
                          </div>
                        </v-tooltip>
                      </template></v-text-field
                    >
                    <v-text-field
                      :value="getDomain()"
                      color="primary"
                      :label="$t('company.access_url.title')"
                      readonly
                      ><template v-slot:append>
                        <v-tooltip top color="white">
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on">mdi-information-outline</v-icon>
                          </template>
                          <div class="grey--text text--darken-3 body-1">
                            {{ $t("company.save.domain.tooltip") }}
                          </div>
                        </v-tooltip>
                      </template></v-text-field
                    >
                    <v-text-field
                      v-model="company.notes"
                      color="primary"
                      :label="$t('company.save.description.title')"
                      :rules="[rules.max_length(250)]"
                      counter="250"
                    >
                      <template v-slot:append>
                        <v-tooltip top color="white">
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on">mdi-information-outline</v-icon>
                          </template>
                          <div class="grey--text text--darken-3 body-1">
                            {{ $t("company.save.description.tooltip") }}
                          </div>
                        </v-tooltip>
                      </template></v-text-field
                    >
                    <!-- Creator role -->
                    <v-autocomplete
                      v-model="company.creator_role"
                      :items="DEFINES.COMPANY_CREATOR_ROLE"
                      item-text="text"
                      item-value="value"
                      :label="$t('company.save.creator_role.title')"
                    >
                      <template v-slot:append>
                        <v-tooltip top color="white">
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on">mdi-information-outline</v-icon>
                          </template>
                          <div class="grey--text text--darken-3 body-1">
                            {{ $t("company.save.creator_role.tooltip") }}
                          </div>
                        </v-tooltip>
                      </template>
                    </v-autocomplete>
                    <!-- Meta keywords -->
                    <v-text-field
                      id="meta_keywords"
                      :label="$t('company.save.meta_keywords.title')"
                      :placeholder="
                        $t('company.save.meta_keywords.placeholder')
                      "
                      name="notes"
                      type="text"
                      v-model="company.meta_info.keywords"
                      class="custom-placeholer-color"
                    >
                      <template v-slot:append>
                        <v-tooltip top color="white">
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on">mdi-information-outline</v-icon>
                          </template>
                          <div class="grey--text text--darken-3 body-1">
                            {{ $t("company.save.meta_keywords.tooltip") }}
                          </div>
                        </v-tooltip>
                      </template></v-text-field
                    >
                  </v-flex>
                </v-layout>
              </v-form>
            </v-flex>
          </v-layout>
        </v-card-text>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import rules from "@/validation";
import { getCurrencySymbol } from "@/helper";

export default {
  name: "CompanyProfile",
  props: {
    company: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      rules,
      local_domain: null
    };
  },
  methods: {
    getDomain() {
      if (this.company.domain) {
        var temp_domain = this.company.domain.split("/");
        if (temp_domain.length == 3) {
          // if company is Vodifa
          this.slugify();
          this.local_domain = this.company.domain;
          return this.company.domain;
        }
        temp_domain[temp_domain.length - 1] = this.slugify();
        this.local_domain = temp_domain.join("/");
        return this.local_domain;
      }
      this.local_domain = `${this.DEFINES.AVAIL_APP_PROTOCOL}${this.slugify()}${
        this.DEFINES.AVAIL_APP_DOMAIN
      }`;
      return this.local_domain;
    },
    slugify() {
      this.company.slug = this.company.slug.split(" ").join("-");
      return this.company.slug;
    },
    getCurrencySymbol() {
      return getCurrencySymbol(this.currency);
    },
  },

};
</script>
